<template>
  <div>
    <el-table
      :data="tableData"
      :header-cell-style="{background:'#41A1FF',color:'#fff'}"
      border
      style="width: 100%"
    >
      <!-- <el-table-column width="100" align="center"></el-table-column> -->
      <el-table-column label="序号" type="index" width="50" align="center"/>
      <el-table-column prop="liability" label="负责人" width="100" >
        <template slot-scope="scope">
          <span
            v-if=" scope.row.executor.length>0"
            style="margin-left: 10px"
          >{{ scope.row.executor[0].name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="task_name"
        show-overflow-tooltip
        label="目标任务"
        width="300"

      />
      <el-table-column
        prop="task_desc"
        show-overflow-tooltip
        label="任务描述"
        width="300"

      />
      <el-table-column prop="planned_complete_time" label="计划完成时间" width="160" />
      <el-table-column prop="complete_time" label="实际完成时间" width="160" />

      <el-table-column prop="liability" label="担责人" width="100" >
        <template slot-scope="scope">
          <span
            v-if=" scope.row.liability.length>0"
            style="margin-left: 10px"
          >{{ scope.row.liability[0].name }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="consultant" label="顾问" width="90" >
        <template slot-scope="scope">
          <span v-if=" scope.row.consultant.length>0">{{ scope.row.consultant[0].name }}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="notify" label="知会人" width="100" >
        <template slot-scope="scope">
          <!-- <span v-if=" scope.row.notify.length>0">{{ scope.row.notify[0].name}}</span> -->
          <span
            v-for="(names,i) in scope.row.notify"
            :key="i"
          ><span v-if=" scope.row.notify.length > 0">{{ names.name }} ,</span></span>

        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="participant " label="参与人" width="100" >
        <template slot-scope="scope">
          <span
            v-for="(names,i) in scope.row.participant"
            :key="i"
          >  <span v-if=" scope.row.participant.length>0">{{ names.name }} ,
        </span></span></template>
      </el-table-column>
      <el-table-column prop="result_status" label="执行结果" width="100" >
        <template slot-scope="scope">
          <span v-if="scope.row.result_status==1">非常差</span>
          <span v-if="scope.row.result_status==2">差</span>
          <span v-if="scope.row.result_status==3">一般</span>
          <span v-if="scope.row.result_status==4">好</span>
          <span v-if="scope.row.result_status==5">非常好</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="difference"
        label="差异分析"
        show-overflow-tooltip
        width="100"

      />
      <el-table-column prop="update_time" label="最后修改时间" width="160" />
      <el-table-column prop="is_complete" label="是否完成" >
        <template slot-scope="scope">
          <span v-if="scope.row.is_complete==0">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>
      <el-table-column prop="history" label="进度" width="200" >
        <template slot-scope="scope">
          <p/>

          <el-tooltip placement="top" effect="light">
            <div slot="content">

              <p v-for="(info,h) in scope.row.history" :key="h" >
                时间： {{ info.add_time }} - 内容：{{ info.content }}
                <br >
              </p>

            </div>
            <div v-if="scope.row.history.length>0"><p style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"> {{ scope.row.history[0].add_time }} - {{ scope.row.history[0].content }}</p></div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="deliver_type" label="交付件类型" width="100" />
      <el-table-column
        prop="deliver_content"
        label="交付件说明"
        show-overflow-tooltip
        width="100"

      />
      <el-table-column show-overflow-tooltip prop="attachments" label="附件" width="100" align="center">
        <template slot-scope="scope">
          <a
            v-for="(item, index) in scope.row.attachments"
            :href="item.href"
            :key="index"
            style="color: #409EFF;display: block;"
          >{{ item.filename }}</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import {
//   tasksearch
// } from "@/api/seedetails"

export default {
  name: 'TaskTable',
  props: {
    meetingtasklist: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      page: 1,
      page_size: 20,
      total: 0,
      tableData: []
    }
  },
  watch: {

    meetingtasklist(newValue, oldValue) {
      this.total = newValue.data.pagination.total
      for (let index = 0; index < newValue.data.tasks.length; index++) {
        const element = newValue.data.tasks[index].attachments
        for (let index = 0; index < element.length; index++) {
          const element1 = element[index]

          element1.href =
            `${process.env.VUE_APP_BASE_API}/common/download/` +
            element1.id
          //  element1.href = " http://190.168.1.50:9095/api/common/download/" + element1.id
        }
      }

      this.tableData = newValue.data.tasks

      // this.tableData = newValue.data.tasks
    },
    deep: true
  },
  mounted() {
    // console.log(this.meeting_id);
    // let data = {
    //   meeting_id: this.meeting_id,
    //   page: this.page,
    //   page_size: this.page_size
    // }
    // this.gettaskTable(data)
    if (this.meetingtasklist !== '') {
      // this.total = this.meetingtasklist.data.pagination.total

      for (
        let index = 0;
        index < this.meetingtasklist.data.tasks.length;
        index++
      ) {
        const element = this.meetingtasklist.data.tasks[index].attachments
        for (let index = 0; index < element.length; index++) {
          const element1 = element[index]

          element1.href =
            `${process.env.VUE_APP_BASE_API}/common/download/` +
            element1.id
          //  element1.href = " http://190.168.1.50:9095/api/common/download/" + element1.id
        }
      }

      this.tableData = this.meetingtasklist.data.tasks
    }
  },
  created() {
    console.log(this.tableData, '数据2512466666')
  },
  methods: {
    // gettaskTable(data) {
    //   tasksearch(data)
    //     .then(response => {
    //       console.log(response);
    //       this.total = response.data.pagination.total
    //       this.tableData=response.data.tasks
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    // handleSizeChange(val) {
    //   this.page_size = val
    //   let data = {
    //     meeting_id: this.meeting_id,
    //     page: this.page,
    //     page_size: this.page_size
    //   }
    //   this.gettaskTable(data)
    // },
    // handleCurrentChange(val) {
    //   this.page = val
    //   let data = {
    //     meeting_id: this.meeting_id,
    //     page: this.page,
    //     page_size: this.page_size
    //   }
    //   this.gettaskTable(data)
    // }
  }
}
</script>
<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
